import React, { useState, useMemo } from "react";
import Slide from "react-reveal/Slide";
import { IonInput, IonButton } from "@ionic/react";
// Comps
// Css
import classes from "./Form.module.scss";
// WebSocket
import { ws } from "api/webSocket";

const Form: React.FC = () => {
  const [name, setName] = useState("");
  const [code, setCode] = useState<number>();

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value);
  };

  const isValid = useMemo(() => {
    if (name && code) return true;
    return false;
  }, [name, code]);

  const handleSubmit = () => {
    if (name && code) ws.joinGame(name, code);
  };

  return (
    <div className={classes.container}>
      <Slide bottom cascade>
        <div className={classes.wrapper}>
          <IonInput
            className={classes.input}
            clearInput
            required
            mode="md"
            value={name}
            placeholder={"Player's Name"}
            onIonChange={handleNameChange}
          />
          <IonInput
            className={classes.input}
            clearInput
            required
            mode="md"
            type="number"
            value={code}
            placeholder={"Game's Code"}
            onIonChange={handleCodeChange}
          />
        </div>
        <IonButton
          className={classes.button}
          disabled={!isValid}
          onClick={handleSubmit}
          size="small"
        >
          submit
        </IonButton>
      </Slide>
    </div>
  );
};

export default Form;
